// Define toggleButtonsBasedOnVariant outside the class
// function toggleButtonsBasedOnVariant(variantValue, optionName, context) {
//   const checksubmitButton = context.querySelector(".product-card__add-to-cart--form .quick-cart-sub-btn");
//   const klaviyoButton = context.querySelector(".klaviyo-bis-trigger");
//   const productVariantsData = context.querySelector("product-card")?.variantsObj;
// // console.log(checksubmitButton,"checksubmitButton");
//   const input = context.querySelector(`input[name="${optionName}"][value="${variantValue}"]`);
//   const quantity = parseInt(input?.getAttribute("data-variant-quantity") || 0);
//   const isAvailable = quantity > 0;

//   // Optionally, find variant ID from variantsObj or form
//   let variantId = null;
//   if (productVariantsData) {
//     const variant = productVariantsData.find((v) => {
//       return v.option1 === variantValue; 
//     });
//     variantId = variant?.id;
//     // console.log(variantId,"variantId");
//   }
//   if (!variantId) {
//     variantId = context.querySelector('.quick-cart-product .product__form input[name="id"]')?.value;
//   }

//   if (isAvailable) {
//     // Show "Add to Cart" button and hide Klaviyo button
//     checksubmitButton?.classList.remove("hidden");
//     klaviyoButton?.classList.add("hidden");
//   } else {
//     // Show Klaviyo button and hide "Add to Cart" button
//     checksubmitButton?.classList.add("hidden");
//     klaviyoButton?.classList.remove("hidden");
//     if (context.setUnavailable) context.setUnavailable(); // Call setUnavailable if defined
//   }

//   // Update form variant ID if available
//   if (variantId && context.querySelector('.quick-cart-product .product__form input[name="id"]')) {
//     context.querySelector('.quick-cart-product .product__form input[name="id"]').value = variantId;
//   }
// }
if (!customElements.get("quick-cart-drawer")) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
        this.parentElement.addEventListener("shopify:section:select", () =>
          this.open()
        );
        this.parentElement.addEventListener("shopify:section:deselect", () =>
          this.close()
        );
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }

      this.querySelector(".button--close").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.querySelector(".quick-cart-drawer__backdrop").addEventListener(
        "click",
        this.close.bind(this)
      );

      this.querySelector(".quick-cart-drawer__blocks").addEventListener(
        "keydown",
        (e) => {
          if (e.key === "Escape" && this.toggleState) {
            this.close();
          }

          if (this.toggleState) {
            const focusableElements = this.querySelectorAll(
              'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
            );
            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement =
              focusableElements[focusableElements.length - 1];

            let isTabPressed = e.key === "Tab";

            if (!isTabPressed) {
              return;
            }

            if (e.shiftKey) {
              if (document.activeElement === firstFocusableElement) {
                e.preventDefault();
                lastFocusableElement.focus();
              }
            } else {
              if (document.activeElement === lastFocusableElement) {
                e.preventDefault();
                firstFocusableElement.focus();
              }
            }
          }
        }
      );

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document
          .querySelectorAll(".quick-cart-drawer__trigger")
          .forEach((element) => {
            if (!element._init) {
              // Daha önce eklenmiş mi kontrol edin
              element.addEventListener("click", (event) => {
                this.fetchProductForQuickCartDrawer(event);
              });
              element._init = true; // Eklenmiş olarak işaretleyin
            }
          });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    async fetchProductForQuickCartDrawer(event) {
      /** stop autoplay on quick cart trigger */
      if (event.target.closest("card-product-slider")) {
        event.target.closest("card-product-slider").slider.autoplay.stop();
        event.target
          .closest("card-product-slider")
          .classList.add("product--open-on-quick-cart");
      }

      const isRecommendations = event.target.classList.contains(
        "quick-cart-drawer__trigger--recommendations"
      );

      const productCard = event.target.closest("product-card");
      let productOptions = null;

      if (!isRecommendations) {
        if (!productCard) return;
        // get all checked options
        productOptions = productCard.querySelectorAll(
          'input[type="radio"]:checked, select'
        );
      }

      const trigger = event.target.closest("[data-product-url]");
      trigger.classList.toggle("is--loading");
      try {
        // const productCardResponse = await fetch(
        //   `${trigger.dataset.productUrl}/?view=quick-cart`
        // );
        // Add locale to the fetch URL
        const locale = window.location.pathname.startsWith('/en/') ? 'en' : 'fr';
        const fetchUrl = locale === 'en' ? `/en${trigger.dataset.productUrl}/?view=quick-cart` : `${trigger.dataset.productUrl}/?view=quick-cart`;
        const productCardResponse = await fetch(fetchUrl);
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const productCard = document.createElement("DIV");
        productCard.insertAdjacentHTML("beforeend", productCardHTML);
        if (!productCard.querySelector(".quick-cart-product")) return;
        this.querySelector(".quick-cart-drawer__main").innerHTML = "";
        this.querySelector(".quick-cart-drawer__main").append(
          productCard.querySelector(".quick-cart-product")
        );

        // Swiper initialization
        // this.sliderInstance = new Swiper(".quick-cart-drawer__media-swiper", {
        //   slidesPerView: 1.25,
        //   spaceBetween: 8,
        //   freeMode: {
        //     enabled: true,
        //   },
        //   breakpoints: {
        //     750: {
        //       slidesPerView: 2,
        //     },
        //   },
        // });
      } catch (error) {
        // console.log(error);
      } finally {
        trigger.classList.toggle("is--loading");

        // Initialize variant button listeners
          this.initVariantButtons();        
        // Re-initialize dropdowns inside the drawer
        initCustomDropdowns(this);

        
        if (!isRecommendations) {
          // update quick cart drawer options with product options
          productOptions.forEach((productOption) => {
            // console.log(productOption);
            const quickCartDrawerOption = this.querySelector(
              `[name="${productOption.name}"][value="${productOption.value}"]`
            );
            const quickCartDrawerOptionLabel =
              quickCartDrawerOption.parentElement.parentElement.querySelector(
                "legend"
              );
            const quickCartDrawerOptionLabelInnerHTML =
              quickCartDrawerOptionLabel.innerHTML;

            // before updating radio button state, remove checked attribute for specific name
            this.querySelectorAll(`[name="${productOption.name}"]`).forEach(
              (radioInput) => {
                radioInput.removeAttribute("checked");
                radioInput.closest("li").classList.remove("checked");
              }
            );

            if (quickCartDrawerOption) {
              quickCartDrawerOption.setAttribute("checked", "");
              const quickCartDrawerOptionLabelSpan =
                quickCartDrawerOptionLabel.querySelector(
                  "[data-selected-variant]"
                );
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = productOption.value;
              }
            }

            // update variant id in product card with selected variant id
            this.querySelector("product-card").querySelector(
              'input[name="id"]'
            ).value = productCard.querySelector('input[name="id"]').value;

            // update radio button state
            if (quickCartDrawerOption) {
              quickCartDrawerOption.closest("li").classList.add("checked");
            }

            // initilise for disabled states to be checked and updated
            this.querySelector("product-card").init();
          });
        }

        // short wait before opening drawer
        setTimeout(() => {
          this.open();
        }, 500);

        // add small delay to open drawer
        // this.open();

        // update label when variant is selected
        this.querySelector(".quick-cart-drawer__main")
          .querySelectorAll(".variant-option-radio-input")
          .forEach((radioInput) => {
            radioInput.addEventListener("change", (event) => {
              const quickCartDrawerOptionLabel =
                event.target.parentElement.parentElement?.querySelector(
                  "legend"
                );
              const quickCartDrawerOptionLabelSpan =
                quickCartDrawerOptionLabel?.querySelector(
                  "[data-selected-variant]"
                );
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = event.target.value;
              }

              // update variant id in product card with selected variant id
              const selectedVariantId = this.querySelector(
                ".product-card__add-to-cart--form input[name='id']"
              ).value;

              // get product variants data
              const productVariantsData =
                this.querySelector("product-card").variantsObj;
              const featuredMedia = productVariantsData.find(
                (variant) => variant.id == selectedVariantId
              )?.featured_media;

              if (featuredMedia) {
                // this.setActiveMedia(featuredMedia.id);
              }
            });
          });
        this.initColorSwatchHandlers();
      }
    }

    
// initVariantButtons to only update image visibility for color options
      initVariantButtons() {
        const priceContainer = document.querySelector('.quick-cart-product .product__content .price__container');    
        const active_pro = document.querySelector('.product-card__quick-cart .product-card__add-to-cart--form .button');  
        if (!priceContainer) return; 
        this.querySelectorAll('.button--variant').forEach((button) => {
          button.addEventListener('click', (e) => {
            const input = button.querySelector('input');
            const selectedVariant = input.value;
            const optionName = input.name;
            const isColorOption = optionName.includes("option[1]"); // Check if this is the color option based on name
            // console.log(e.target.baseURI, "baseURI");
            if (e.target.baseURI.includes("zips")) {
                if (isColorOption) { // Only update image visibility for color options
                  const mediaElements = this.querySelectorAll('.quick-cart-drawer__media-swiper .swiper-slide');
                   let found = false;
                  mediaElements.forEach((media) => {
                    const img = media.querySelector('img');
                    if (!found && img && img.getAttribute('alt') === selectedVariant) {
                      found = true;
                      media.style.display = 'block';
                    } else {
                      media.style.display = 'none';
                    }
                  });
                }
            }
            let price = button.getAttribute("price");
            let compare_at_price = button.getAttribute("price-comp");
            let priceValue = parseFloat(price.replace("€", "").trim());
            let compareAtValue = compare_at_price ? parseFloat(compare_at_price.replace("€", "").trim()) : null;
            if (compareAtValue !== null && compareAtValue > priceValue) {
              // generate html block and append to price container
              const priceHtml = `
                <div class="price__sale">
                  <div class="price__sale-inner">
                    <span class="price__sale-inner-span price__regultate-change" price-qty="${price}" symbol="€">
                      <span class="visually-hidden">Prix réduit</span>
                      <span>${price}</span>
                    </span>
                    <span class="visually-hidden">Prix régulier</span>
                    <s class="price__regultate-compare" price-comp-qty="${compare_at_price}" symbol="€">${compare_at_price}</s>
                  </div>
                </div>
              `;
              priceContainer.innerHTML = priceHtml;
              
            } else {
              // generate html block and append to price container
              const priceHtml = `
                <div class="price__sale">
                  <div class="price__sale-inner price__regultate-change" price-qty="${price}" symbol="€">
                    <span class="visually-hidden">Prix régulier</span>
                    ${price}
                  </div>
                </div>
              `;
              priceContainer.innerHTML = priceHtml;
            }
            // Toggle buttons based on variant availability
              // toggleButtonsBasedOnVariant(selectedVariant, optionName, this);
            
          });
        });
      }

    
    initColorSwatchHandlers() {
      const self = this;
      document
        .querySelectorAll(".color-swatch-collection")
        .forEach(function (button) {
          button.addEventListener("click", function () {
            const productHandle = this.getAttribute("cstm-data-swatch");
            // console.log("productHandle", productHandle);
            fetch(`${productHandle}/?view=quick-cart`)
              .then(function (response) {
                return response.text();
              })
              .then(function (productHTML) {
                const tempContainer = document.createElement("DIV");
                tempContainer.innerHTML = productHTML;
                const productCard = tempContainer.querySelector(
                  ".quick-cart-product"
                );
                if (productCard) {
                  const quickCartMain = document.querySelector(
                    ".quick-cart-drawer__main"
                  );
                  if (quickCartMain) {
                    quickCartMain.innerHTML = "";
                    quickCartMain.append(productCard);
                    
                    // Re-initialize dropdowns inside the drawer
                    initCustomDropdowns(this);
                  }
                }
                self.initColorSwatchHandlers();
              })
              .catch(function (error) {
                console.log("Error fetching product HTML:", error);
              });
          });
        });
    }

    // setActiveMedia(id) {
    //   const mediaFound = Array.from(
    //     this.querySelectorAll("[data-media-id]")
    //   ).find((media) => Number(media.dataset.mediaId) === id);
    //   if (mediaFound) {
    //     this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
    //   }
    // }

    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      const quickCartDrawer = document.querySelector(
        ".quick-cart-drawer__blocks"
      );
      const closeButton = quickCartDrawer.querySelector(".button--close");
      quickCartDrawer.setAttribute("tabindex", "0");
      closeButton.setAttribute("tabindex", "0");
      this.classList.add("is--open");
      this.opened();

      const firstFocusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close() {
      this.toggleState = false;

      const shopTheLookDrawer = document.querySelector("shop-the-look-drawer");

      if (
        shopTheLookDrawer &&
        !shopTheLookDrawer.classList.contains("is--open")
      ) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      if (!shopTheLookDrawer) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      this.classList.remove("is--open");
      this.closed();
      this.toggleAriaExpanded();

      /** start autoplay on quick cart drawe close */
      if (
        document.querySelector(
          "card-product-slider.product--open-on-quick-cart"
        )
      ) {
        document
          .querySelector("card-product-slider.product--open-on-quick-cart")
          .slider.autoplay.start();
        document
          .querySelector("card-product-slider.product--open-on-quick-cart")
          .classList.remove("product--open-on-quick-cart");
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target.closest("button").setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute(
          "aria-expanded",
          true
        );
      } else {
        document
          .querySelectorAll('[aria-controls="quick-cart-drawer"]')
          .forEach((button) => {
            button.setAttribute("aria-expanded", false);
          });
      }
    }

    opened() {
      const openedEvent = new Event("opened", { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event("closed", { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define("quick-cart-drawer", QuickCartDrawer);
}

// Custom dropdown logic (runs initially and after drawer update)
function initCustomDropdowns(context = document) {
  context.querySelectorAll('.custom-variant-dropdown').forEach(dropdown => {
    // Prevent duplicate bindings
    if (dropdown._init) return;
    dropdown._init = true;
    
    const toggle = dropdown.querySelector('.custom-dropdown-variant-toggle');
    const selected = toggle.querySelector('.custom-dropdown-variant-selected-option');
    const options = dropdown.querySelectorAll('.custom-dropdown-variant-option');
    const formBtn = document.querySelector('.quick-cart-product .product__form input[name="id"]');
    const priceContainer = document.querySelector('.quick-cart-product .product__content .price__container');    

    if (!priceContainer) return; 
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      //Close other dropdowns, but not this one
      closeAllDropdowns(dropdown);
      dropdown.classList.toggle('open');
    });

    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        if (option.classList.contains('disabled')) return;
        const value = option.getAttribute('data-value');
        const id = option.getAttribute('data-id');
        const optionName = option.closest('.custom-variant-dropdown').getAttribute('data-option-name') || 'option[1]'; // Adjust based on your structure
        selected.textContent = value;
        if (formBtn) {
          formBtn.value = id;
        }

        let price = option.getAttribute("price");
        let compare_at_price = option.getAttribute("price-comp");
        let priceValue = parseFloat(price.replace("€", "").trim());
        let compareAtValue = compare_at_price ? parseFloat(compare_at_price.replace("€", "").trim()) : null;
        if (compareAtValue !== null && compareAtValue > priceValue) {
          const priceHtml = `
            <div class="price__sale">
              <div class="price__sale-inner">
                <span class="price__sale-inner-span price__regultate-change" price-qty="${price}" symbol="€">
                  <span class="visually-hidden">Prix réduit</span>
                  <span>${price}</span>
                </span>
                <span class="visually-hidden">Prix régulier</span>
                <s class="price__regultate-compare" price-comp-qty="${compare_at_price}" symbol="€">${compare_at_price}</s>
              </div>
            </div>
          `;
          priceContainer.innerHTML = priceHtml;
        } else {
          const priceHtml = `
            <div class="price__sale">
              <div class="price__sale-inner price__regultate-change" price-qty="${price}" symbol="€">
                <span class="visually-hidden">Prix régulier</span>
                ${price}
              </div>
            </div>
          `;
          priceContainer.innerHTML = priceHtml;
        }
        dropdown.classList.remove('open');
        // console.log("Selected Variant Option:", value);
        // console.log("Selected Variant id:", id);
        // console.log('formBtn',formBtn);
        // Toggle buttons based on variant availability
        // toggleButtonsBasedOnVariant(value, optionName, context);

        
      });
    });
  });

  //Close all dropdowns on outside click
  document.addEventListener("click", () => closeAllDropdowns());

  function closeAllDropdowns(exceptionDropdown = null) {
    document.querySelectorAll(".custom-variant-dropdown.open").forEach(d => {
      if (d !== exceptionDropdown) {
        d.classList.remove("open");
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  initCustomDropdowns(); 
});
